import React, { useEffect, useState, useCallback, useContext } from 'react'
import styled, { ThemeContext } from 'styled-components'
import { Text } from 'rebass'
import { BigNumber } from 'bignumber.js'

// utils
import { BIGNUMBER_FMT } from '../../../constants/bakery'
import { PokercardProps } from '../../../constants/pokercard'
import { ButtonConfirmed } from '../../../components/Button'
import { stopPropagation } from '../../../utils/func'
import useOpenBlindBox from '../../../hooks/nft/useOpenBlindBox'
import { AutoRow, RowBetween } from '../../../components/Row'
import Loader from '../../../components/Loader'
import TransferModal from '../../BakeryArtworks/components/TransferModal'

import { NFTTYPE } from '../../../constants/bakery/nft'
import useApproveAllERC721 from '../../../hooks/nft/useApproveAllERC721'
import useStakeDish from '../../../hooks/nft/useStakeDish'
import useUserStakes from '../../../hooks/nft/useUserStakes'
import useUnstakeDish from '../../../hooks/nft/useUnstakeDish'
import useModal from '../../../hooks/bakery/useModal'
import useAllowanceNFT from '../../../hooks/nft/useAllowanceNFT'
import useApproveDish from '../../../hooks/nft/useApproveNFT'
import useBlock from '../../../hooks/bakery/useBlock'
import usePokerCardRoi from '../../../hooks/nft/usePokerCardRoi'
const ArtworksCard = styled.div<{wd?: string}>`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: ${({ wd }) => wd ? '0 0 21px' : '16px'};
  background-color: ${({ theme }) => theme.bsBg15};
  border-radius: 28px;
  width: ${({ wd }) => wd ? wd : '276px'};
  min-height: 513px;
  margin-bottom: 25px !important;
  text-decoration: none;
  cursor: pointer;
  &:hover {
    background-color: ${({ theme }) => theme.bsBg27};
    box-shadow: 0px 2px 10px rgba(171, 133, 115, 0.16);
  }
  margin-right: 12px;
  margin-left: 12px;
`
const IconArtwork = styled.div<{bg?: string, wd?: string}>`
  display: block;
  width: ${({ wd }) => wd ? wd : '244px'};
  height: ${({ wd }) => wd ? '362' : '325'}px;
  border-radius: ${({ wd }) => wd ? '0' : '18'}px;
  background-image: url(${({bg}) => (bg ? bg : '')});
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
`
const CardHead = styled.div`
  position: relative;
  width: 100%;
`
const CardFoot = styled.div<{pad?: string}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${({ pad }) => pad ? pad : '0'};
  overflow: hidden;
`

const Title = styled.div<{mar?: string}>`
  margin: ${({ mar }) => mar ? mar : '30px 0 20px'};
  width: 100%;
  font-size: 16px;
  line-height: 22px;
  height: 44px;
  overflow-y: hidden;
  font-family: Baloo Da;
  font-weight: bold;
  font-size: 22px;
  color: ${({ theme }) => theme.bsText7};
`

const ArtworkLevel = styled.div`
  display: flex;
  margin-bottom: 15px;
  width: 100%;
  height: 17px;
  justify-content: space-between;
`

export default function Artworks({artwork, type, isMyArtwork, allowanceStake, bnbAmount}: {artwork: PokercardProps, type: string, isMyArtwork?: boolean, allowanceStake?: boolean, bnbAmount?: number}) {
  const theme = useContext(ThemeContext)

  let isGameBox = false
  if (type && [NFTTYPE.GAMEBOX].includes(type)) {
    isGameBox = true
  }

  // 开盲盒
  const { onOpenBlindBox } = useOpenBlindBox(artwork.tokenId, type === NFTTYPE.GAMEBOX ? 'GAMEBOXBURN' : type)
  const [requestedOpen, setRequestedOpen] = useState(false)
  const handleOpen = useCallback(async (event) => {
    try {
      stopPropagation(event)
      setRequestedOpen(true)
      const txHash = await onOpenBlindBox()
      if (!txHash) {
        setRequestedOpen(false)
      } else {
        setTimeout(() => {
          setRequestedOpen(false)
        }, 10000)
      }
    } catch (e) {
      console.log(e)
    }
  }, [onOpenBlindBox])

  // approve
  const STAKE = 'STAKE'
  const DECOMPOSE = 'DECOMPOSE'
  const [requestedApproval, setRequestedApproval] = useState(false)
  const [resetApprovalStake, setResetApprovalStake] = useState(false)
  const [requestedApprovalDecompose, setRequestedApprovalDecompose] = useState(false)
  const allowance = useAllowanceNFT({
    tokenId: artwork.tokenId,
    requested: requestedApproval || requestedApprovalDecompose,
    reset: resetApprovalStake,
    type: type === NFTTYPE.GAMEBOX ? 'GAMEBOXBURN' : type
  })

  // 授权质押PokerCard
  const { onApprove } = useApproveDish(artwork.tokenId, type === NFTTYPE.GAMEBOX ? 'GAMEBOXBURN' : type)
  const onApprove721 = useApproveAllERC721(type)
  const handleApprove = useCallback(
    async (type: string) => {
      try {
        // stopPropagation(event)
        if (type === STAKE) {
          setRequestedApproval(true)
        } else {
          setRequestedApprovalDecompose(true)
        }
        const txHash = type !== STAKE ? await onApprove() : await onApprove721()
        if (!txHash) {
          if (type === STAKE) {
            setRequestedApproval(false)
          } else {
            if (type === STAKE) {
              setRequestedApproval(false)
            } else {
              setRequestedApprovalDecompose(false)
            }
          }
        } else {
          setTimeout(() => {
            setRequestedApproval(false)
          }, 10000)
        }
      } catch (e) {
        console.log(e)
      }
    },
    [onApprove, setRequestedApproval, onApprove721]
  )

  // 质押扑克牌
  const { onStakeDish } = useStakeDish(artwork.tokenId, type)
  const [requestedStake, setRequestedStake] = useState(false)
  const handleStake = useCallback(async (event) => {
    try {
      stopPropagation(event)
      setRequestedStake(true)
      const txHash =  await onStakeDish()
      if (!txHash) {
        setRequestedStake(false)
      } else {
        setTimeout(() => {
          setRequestedStake(false)
        }, 10000)
      }
    } catch (e) {
      console.log(e)
    }
  }, [onStakeDish])

  // 解押扑克牌
  const onUnstakeDish = useUnstakeDish(artwork.tokenId, type)
  const [requestedUnstake, setRequestedUnstake] = useState(false)
  const handleUnstake = useCallback(async (event) => {
    try {
      stopPropagation(event)
      setRequestedUnstake(true)
      const txHash = await onUnstakeDish()
      if (!txHash) {
        setRequestedUnstake(false)
      } else {
        setResetApprovalStake(false)
        setTimeout(() => {
          setResetApprovalStake(true)
          setRequestedUnstake(false)
        }, 10000)
      }
    } catch (e) {
      console.log(e)
    }
  }, [onUnstakeDish])

  // 获取我的stake
  const getStakes = useUserStakes(type)
  const emptyStakes: any[] = []
  const [stakesIds, setStakesIds] = useState(emptyStakes)
  const getStakesIds = useCallback(async () => {
    const stakes = await getStakes()
    if (stakes.length) {
      const stakesId = stakes.map((d: any) => {
        return d
      })
      setStakesIds(stakesId)
    } else {
      setStakesIds([])
    }
  }, [getStakes])

  useEffect(() => {
    getStakesIds()
  }, [artwork, getStakesIds])

  // Transfer
  const [artworkTransferExchange] = useModal(
    <TransferModal
      tokenId={artwork.tokenId}
      title="Input the Address"
      type={type}
    />,
  )
  
  // 计算rio
  const currentBlock = useBlock()
  let transformBnbPrice = 2 
  const pokerRoi = usePokerCardRoi(currentBlock, type, artwork.stakingPower,transformBnbPrice)
  const roi  = pokerRoi || new BigNumber(0)
  return (
    <ArtworksCard wd={isGameBox ? '280px' : ''} className='fourItem'>
      <CardHead>
        <IconArtwork bg={artwork.image} wd={isGameBox ? '280px' : ''} />
      </CardHead>
      <CardFoot pad={isGameBox ? '0 16px' : ''}>
        <Title mar={isGameBox ? '26px 0 2px' : ''}>
          {artwork.titleName}
          {' # ' + artwork.tokenId}
        </Title>
        {
          isGameBox ? <>
            <ArtworkLevel style={{marginBottom: '13px'}}>
              <Text fontSize={14} fontFamily={'Yuanti SC'} color={theme.bsText7}>Current APY:</Text>
              <Text fontSize={16} fontFamily={'Yuanti SC'} fontWeight={700} color={theme.bsText7}>
                {bnbAmount && new BigNumber(bnbAmount).toFormat(2, BIGNUMBER_FMT)} %
              </Text>
            </ArtworkLevel>
            <ArtworkLevel>
              <Text fontSize={14} fontFamily={'Yuanti SC'} color={theme.bsText7}>TLM to get when Burn:</Text>
              <Text fontSize={16} fontFamily={'Yuanti SC'} fontWeight={700} color={theme.bsText7}>1500</Text>
            </ArtworkLevel>
            <ArtworkLevel>
              <Text fontSize={14} fontFamily={'Yuanti SC'} color={theme.bsText7}>ALICE to get when Burn:</Text>
              <Text fontSize={16} fontFamily={'Yuanti SC'} fontWeight={700} color={theme.bsText7}>20</Text>
            </ArtworkLevel>
            <ArtworkLevel style={{marginBottom: '23px'}}>
              <Text fontSize={14} fontFamily={'Yuanti SC'} color={theme.bsText7}>PET to get when Burn:</Text>
              <Text fontSize={16} fontFamily={'Yuanti SC'} fontWeight={700} color={theme.bsText7}>20</Text>
            </ArtworkLevel>
          </> : <>
            <ArtworkLevel>
              <Text fontSize={14} color={theme.bsText7}>Current APY:</Text>
              <Text fontSize={14} fontWeight={700} color={theme.bsText7}>
              {
                artwork.name === 'blindbox' ? (
                  <Text fontSize={14} fontWeight={700} color={theme.bsText7}>-</Text>
                ) : 
                roi && !roi.isNaN() && roi.gt(0) ? roi.times(new BigNumber(100)).toFormat(2, BIGNUMBER_FMT) + '%' : '-'
              }
              </Text>
            </ArtworkLevel>
            <ArtworkLevel>
              <Text fontSize={14} color={theme.bsText7}>Staking Power:</Text>
              {
                artwork.name === 'blindbox' ? (
                  <Text fontSize={14} fontWeight={700} color={theme.bsText7}>-</Text>
                ) : (
                  <Text fontSize={14} fontWeight={700} color={theme.bsText7}>{artwork.stakingPower ? new BigNumber(artwork.stakingPower).toNumber() : '-'}</Text>
                )
              }
            </ArtworkLevel>
           </>
        }
        {
          isMyArtwork ? 
            (artwork.name === 'blindbox') ? (
              <ButtonConfirmed
                onClick={handleOpen}
                disabled={requestedOpen}
                fontSize={14}
                height={40}
                altDisabledStyle={requestedOpen} // show solid button while waiting
                style={{
                  padding: '0',
                  width: '100%'
                }}
              >
                {
                  requestedOpen ? (
                    <AutoRow gap="6px" justify="center">
                      Opening <Loader stroke="white" />
                    </AutoRow>
                  ) : (
                    'Open'
                  )
                }
              </ButtonConfirmed>
            ) : stakesIds.includes(artwork.tokenId) ? (
              <ButtonConfirmed
                onClick={handleUnstake}
                disabled={requestedUnstake}
                fontSize={14}
                height={40}
                altDisabledStyle={requestedUnstake} // show solid button while waiting
                style={{
                  padding: '0',
                  width: '100%'
                }}
              >
                {
                  requestedUnstake ? (
                    <AutoRow gap="6px" justify="center">
                      Unstaking <Loader stroke="white" />
                    </AutoRow>
                  ) : (
                    'Unstake'
                  )
                }
              </ButtonConfirmed>
            )
            : <RowBetween>
              {
                type && [NFTTYPE.GAMEBOX].includes(type) ? allowance ? (
                  <ButtonConfirmed
                    onClick={handleOpen}
                    disabled={requestedOpen || requestedStake || requestedApproval}
                    fontSize={14}
                    marginRight={12}
                    height={40}
                    altDisabledStyle={requestedOpen || requestedStake || requestedApproval} // show solid button while waiting
                  >
                    {requestedOpen ? 'Burning' : 'Burn'}
                  </ButtonConfirmed>
                ) : (
                  <ButtonConfirmed
                    onClick={handleApprove.bind(null, DECOMPOSE)}
                    disabled={requestedApprovalDecompose || requestedStake || requestedApproval}
                    fontSize={14}
                    marginRight={12}
                    height={40}
                    altDisabledStyle={requestedApprovalDecompose || requestedStake || requestedApproval} // show solid button while waiting
                  >
                    {requestedApprovalDecompose ? 'Approving' : 'Burn'}
                  </ButtonConfirmed>
                ) : null
              }
              {
                allowanceStake ? (
                  <ButtonConfirmed
                    onClick={handleStake}
                    disabled={requestedStake}
                    fontSize={14}
                    height={40}
                    altDisabledStyle={requestedStake} // show solid button while waiting
                    style={{
                      padding: '0',
                      width: '100%'
                    }}
                  >
                    {
                      requestedStake ? (
                        <AutoRow gap="6px" justify="center">
                          Staking <Loader stroke="white" />
                        </AutoRow>
                      ):  (
                        'Stake'
                      )
                    }
                  </ButtonConfirmed>
                ) :(
                  <ButtonConfirmed
                    onClick={handleApprove.bind(null, STAKE)}
                    disabled={requestedApproval}
                    fontSize={14}
                    height={40}
                    altDisabledStyle={requestedApproval} // show solid button while waiting
                    style={{
                      padding: '0',
                      width: '100%'
                    }}
                  >
                    {
                      requestedApproval ? (
                        <AutoRow gap="6px" justify="center">
                          Approving <Loader stroke="white" />
                        </AutoRow>
                      ):  (
                        isGameBox ? 'Approve' : 'Approve ' + artwork.nftName
                      )
                    }
                  </ButtonConfirmed>
                )
              }
            </RowBetween> : false
        }
        {
          isGameBox ? (
          <ButtonConfirmed
            marginTop="10px"
            height={40}
            padding="0 5px"
            fontSize={14}
            disabled={!(isMyArtwork && !stakesIds.includes(artwork.tokenId)) || requestedOpen || requestedStake || requestedApproval}
            altDisabledStyle={!(isMyArtwork && !stakesIds.includes(artwork.tokenId)) || requestedOpen || requestedStake || requestedApproval}
            onClick={artworkTransferExchange}
          >
            Transfer
          </ButtonConfirmed>
          ) : false
        }
      </CardFoot>
    </ArtworksCard>
  )
}
